<template>
    <div class="snackbar__wrapper">
        <div class="container">
            <div class="row justify-content-center">
                <snackbar
                    v-for="snackbar in snackbars"
                    :key="snackbar.id"
                    :type="snackbar.type"
                    :prop-obj="snackbar"
                    @closed="onSnackbarClosed"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import Snackbar from './Snackbar.vue'

    export default {
        components: {
            Snackbar
        },
        props: {
            snackbars: {
                required: false,
                type: Array
            }
        },
        methods: {
            onSnackbarClosed(id) {
                this.$emit('remove', id);
            }
        }
    }
</script>

<style lang="scss">
    .snackbar {
        pointer-events: all;

        &__wrapper {
            pointer-events: none;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
</style>
